import { ReactComponent as QuestionIcon } from "../../static/images/question_sign.svg";
import { useTranslation } from "react-i18next";

import CustomButton from "../CustomButton";

import "./style.scss";

const ModalConfirmation = ({
  modalText,
  modalSubText,
  changeModal,
  modalValue,
  cancelButtonText,
  confirmButtonText,
  confirm,
  cancel,
  inputModal,
  hideIcon = false,
  error = "",
}) => {
  // modal-confirm

  const { t } = useTranslation();

  const handleConfirm = async () => {
    try {
      if (changeModal) {
        changeModal("");
      }

      confirm();
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <div className={`modal-container ${modalValue}`}>
      <div className="modal-content">
        {!hideIcon && (
          <div className="modal-image">
            <QuestionIcon />
          </div>
        )}
        <div className="modal-text">
          <h3>{modalText}</h3>
        </div>
        <div className="modal-sub-text">
          <span>{modalSubText}</span>
        </div>
        <div className="input-modal">{inputModal}</div>{" "}
        {!!error && (
          <div className="modal-error">
            <span>{error}</span>
          </div>
        )}
        <div className="modal-buttons">
          <CustomButton
            color="error"
            id="modal-cancel"
            onClick={(e) => {
              if (changeModal) {
                changeModal("");
              }
              if (cancel) {
                cancel(e);
              }
            }}
          >
            {cancelButtonText ? cancelButtonText : t("cancel")}
          </CustomButton>

          <CustomButton onClick={() => handleConfirm()}>
            {confirmButtonText ? confirmButtonText : t("confirm")}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmation;
